<template>
<div class="promo-tile" :style="'background-image: url(' + item.bg.url + ');'">
    <div class="section has-text-centered">
        <p class="title is-6 is-lighter" v-if="item.content" v-html="item.content"></p>
        <h2 class="title is-2">{{item.title}}</h2>
        <div class="action">
            <a v-if="item.link.is_external" class="button is-primary" :href="item.link.url" target="_blank">{{item.link.title}}</a>
            <router-link class="button is-primary" :to="item.link.url">{{item.link.title}}</router-link>
        </div>
    </div>
</div>
</template>

<script>
export default {
    name    :   'PromoTile',
    props   :   ['item']
}
</script>



// WEBPACK FOOTER //
// src/components/blocks/PromoTile.vue